import io from 'socket.io-client';
import restApi from '../Api/Rest.api'
import socketsApi from '../Api/Sockets.api';
import { Deferred } from './Deferred';


/**
 * UserService Implementation
 */
class UserService {

    loggedIn: boolean
    groups: any
    devices: any
    deviceGroups: any
    programs: any
    actions: any
    actionGroups: any
    datasets: any
    user: any
    cpuData:any
    ramData:any
    gpuData: any
    cpuTempData: any
    gpuTempData: any
    scope: any
    ready: Deferred<void> = new Deferred()



    /**
     * Constructs UserService Instance
     */
    constructor() {
        this.loggedIn = false
        this.groups = []
        this.devices = []
        this.deviceGroups = []
        this.programs = []
        this.actions = []
        this.actionGroups = []
        this.datasets = []
        this.cpuData = [{ x: 65, y: 75 },
                    { x: 59, y: 49 },
                    { x: 80, y: 90 },
                    { x: 81, y: 29 },
                    { x: 56, y: 36 },
                    { x: 55, y: 25 },
                    { x: 40, y: 18 },
                    { x: 45, y: 20 },
                    { x: 49, y: 18 },]
            this.gpuData = [{ x: 55, y: 25 },
            { x: 59, y: 49 },
            { x: 40, y: 18 },
            { x: 81, y: 29 },
            { x: 56, y: 36 },
            { x: 80, y: 90 },
            { x: 56, y: 36 },
            { x: 55, y: 25 },
            { x: 56, y: 36 },
            ]
            this.ramData = [{ x: 65, y: 75 },
            { x: 59, y: 49 },
            { x: 80, y: 90 },
            { x: 81, y: 29 },
            { x: 56, y: 36 },
            { x: 55, y: 25 },
            { x: 40, y: 18 }]
            this.cpuTempData = [{ x: 65, y: 75 },
            { x: 59, y: 49 },
            { x: 80, y: 90 },
            { x: 81, y: 29 },
            { x: 56, y: 36 },
            { x: 55, y: 25 },
            { x: 70, y: 88 }]
            this.gpuTempData = [{ x: 45, y: 55 },
            { x: 59, y: 49 },
            { x: 86, y: 96 },
            { x: 70, y: 90 },
            { x: 81, y: 69 },
            { x: 45, y: 65 },
            { x: 72, y: 78 }]
            this.scope = ["scope.object", "scope.global"]

        const user = localStorage.getItem('user');

        if (user) {
            const _user = JSON.parse(user)
            this.user = _user

            console.log(_user)
        }
    }
        

    init(user: any) {

        this.user = user

        console.log(user)

        return;

        socketsApi.socket.on('connect', () => {
            this.onConnect()
        });

        socketsApi.socket.on('disconnect', () => {
            this.onDisconnect()
        });
        // socketsApi.socket.on('programs', (data: any) => {
        //     console.log('programs are', data)

        //     this.programs = data;
        //     if (this.ready.isPending()) {
        //         this.ready.resolve()
        //     }
        // });
        // socketsApi.socket.on('devices', (data: any) => {
        //     console.log('devices are', JSON.stringify(data))

        //     this.groups = data
        //     //console.log(this.hubs)
        //     if (this.ready.isPending()) {
        //         this.ready.resolve()
        //     }
        //     //this.onDevices(data)
        // });

        // socketsApi.socket.on('deviceGroups', (data: any) => {
        //     console.log('deviceGroups are', data)

        //     this.deviceGroups = data;
        //     if (this.ready.isPending()) {
        //         this.ready.resolve()
        //     }
        // });

        socketsApi.socket.on('actions', (data: any) => {
            console.log('actions are', data)

            this.actions = this.groupBy(data, "deviceTypeId");
            if (this.ready.isPending()) {
                this.ready.resolve()
            }
        });

        socketsApi.socket.on('actionGroups', (data: any) => {
            console.log('actionGroups', data)
            this.actionGroups = data;
        });

        socketsApi.socket.on('datasets', (data: any) => {
            console.log('Datasets are', data)

            this.datasets = data
            if (this.ready.isPending()) {
                this.ready.resolve()
            }
        });

        socketsApi.socket.on('metrics', (data: any) => {
            this.onMetrics(data)
            this.cpuData.push(data.cpu)
            this.ramData.push(data.ram)
            this.gpuData.push(data.gpu)
            this.cpuTempData.push(data.cpu_temp)
            this.gpuTempData.push(data.gpu_temp)
        });

        socketsApi.socket.on('activeBlock', (data: any) => {
            this.onActiveBlock(data)
        });

        socketsApi.socket.on('programDone', (data: any) => {
            this.onProgramDone(data)
        });

        socketsApi.socket.on('triggered', (data: any) => {
            console.log('triggered', data)
            this.onTriggered(data)
        });


        socketsApi.socket.on('updateProgram', (data: any) => {
            console.log('program', data)
            this.onUpdateProgram(data)
        });

        socketsApi.socket.on('notify', (data: any) => {
            console.log('notify', data)
            this.onNotify(data)
        });

        // this.groups = this.getDevices()
        // this.deviceGroups = this.getDeviceGroups();
        // this.programs = this.getPrograms()
        this.actions = this.getActions()
        this.actionGroups = this.getActionGroups();
        this.datasets = this.getDatasets()

    }

    trigger(deviceId: string, actionId: string, params: any) {
        socketsApi.socket.emit('trigger', {
            deviceId: deviceId,
            actionId: actionId,
            inputs: params
        });
    }

    script(deviceId: string, actionId: string, params: any) {
        socketsApi.socket.emit('script', {
            deviceId: deviceId,
            actionId: actionId,
            inputs: params
        });
    }

    runProgram(program: any) {
        console.log("running", program);
        socketsApi.socket.emit('runProgram',  program);
    }

    updateProgram(program: any) {
        console.log(program);
        socketsApi.socket.emit('updateProgram', {
            program
        });
    }

    // addProgram(program:any) {
    //     return new Promise((resolve, reject) => {
    //         socketsApi.socket.emit('addProgram', {
    //             program
    //           }, (response: any) => {
    //                 resolve(response);
    //           });
    //     })

    // }

    addDataset(dataset:any) {
        console.log(socketsApi.socket)
        socketsApi.socket.emit('addDataset', {
          dataset
        });
    }

    // getGroups() {
    //     return this.groups
    // }

    // getGroup(id: string) {
    //     return this.groups.find((group:any) => group.id == id)
    // }

    // getDevices() {
    //     socketsApi.socket.emit('getDevices', {message: "test"});
    // }

    // getDevice(deviceId: number) {
    //     console.log({deviceId});
    //     return new Promise((resolve, reject) => {
    //         socketsApi.socket.emit('getDevice', {
    //             deviceId
    //           }, (response: any) => {
    //                 resolve(response);
    //           });
    //     })
    // }

    updateDeviceSettings(deviceId: number, settings: any) {
        console.log({deviceId, settings});
        return new Promise((resolve, reject) => {
            socketsApi.socket.emit('updateDeviceSettings', {
                deviceId,
                settings
              }, (response: any) => {
                    resolve(response);
              });
        })
    }

    // getDeviceGroups() {
    //     socketsApi.socket.emit('getDeviceGroups', {message: "test"});
    // }

    // getPrograms() {
    //     socketsApi.socket.emit('getPrograms', {message: "test"});
    // }

    // getProgram(programId: number) {
    //     console.log({programId});
    //     return new Promise((resolve, reject) => {
    //         socketsApi.socket.emit('getProgram', {
    //             programId
    //           }, (response: any) => {
    //                 resolve(response);
    //           });
    //     })
    //     // return this.programs.find((program:any) => program.id == programId)
    // }

    getActions() {
        socketsApi.socket.emit('getActions', {});
    }

    getActionGroups(deviceTypeId = null) {
        return new Promise((resolve, reject) => {
            socketsApi.socket.emit('getActionGroups', {
                deviceTypeId
              }, (response: any) => {
                    console.log('response', response)
                    resolve(response);
              });
        })
    }

    getDatasets() {
        socketsApi.socket.emit('getDatasets', {message: "TEST TEST TEST"});
    }

    onConnect() {
        console.log('sockets connected')
    }

    onDisconnect() {
        console.log('sockets disconnected')
    }

    onDevices(device: any) {
        console.log(device)
    }

    onPrograms() {
        return this.programs
    }

    onDeviceGroups() {
        return this.deviceGroups
    }


    onTriggered(msg: any) {
        console.log(msg)
    }

    onMetrics(msg: any) {

        console.log("GPU D:",this.gpuTempData)
    }

    onActiveBlock(msg: any) {
        console.log(msg);
        //console.log(msg)
    }

    onProgramDone(msg: any) {
        console.log(msg)
    }

    onActions(actions: any) {
        console.log(actions)
    }

    onActionGroups(actionGroups: any) {
        console.log("acctione", actionGroups)
        return actionGroups;
    }

    onUpdateProgram(data: any) {

        console.log(data)
    }


    onNotify(notif: any) {
        console.log(notif)
    }

    groupBy(arr, prop) {
        const map = new Map(Array.from(arr, obj => [obj[prop], []]));
        arr.forEach(obj => map.get(obj[prop]).push(obj));
        return Array.from(map.values());
    }

}

export default new UserService()